import {Injectable} from '@angular/core';
import {SelectItem} from '../common/selectitem';
export class ObjectUtils {
/**
 * @param {?} obj1
 * @param {?} obj2
 * @param {?=} field
 * @return {?}
 */
public equals(obj1: any, obj2: any, field?: string): boolean {
        if (field)
            return (this.resolveFieldData(obj1, field) === this.resolveFieldData(obj2, field));
        else
            return this.equalsByValue(obj1, obj2);
    }
/**
 * @param {?} obj1
 * @param {?} obj2
 * @param {?=} visited
 * @return {?}
 */
public equalsByValue(obj1: any, obj2: any, visited?: any[]): boolean {
        if (obj1 == null && obj2 == null) {
            return true;
        }
        if (obj1 == null || obj2 == null) {
            return false;
        }

        if (obj1 == obj2) {
            return true;
        }

        if (typeof obj1 == 'object' && typeof obj2 == 'object') {
            if (visited) {
                if (visited.indexOf(obj1) !== -1) return false;
            } else {
                visited = [];
            }
            visited.push(obj1);

            for (var /** @type {?} */ p in obj1) {
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
                    return false;
                }

                switch (typeof (obj1[p])) {
                    case 'object':
                        if (!this.equalsByValue(obj1[p], obj2[p], visited)) return false;
                        break;

                    case 'function':
                        if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
                        break;

                    default:
                        if (obj1[p] != obj2[p]) return false;
                        break;
                }
            }

            for (var /** @type {?} */ p in obj2) {
                if (typeof (obj1[p]) == 'undefined') return false;
            }

            delete obj1._$visited;
            return true;
        }

        return false;
    }
/**
 * @param {?} data
 * @param {?} field
 * @return {?}
 */
resolveFieldData(data: any, field: string): any {
        if(data && field) {
            if(field.indexOf('.') == -1) {
                return data[field];
            }
            else {
                let /** @type {?} */ fields: string[] = field.split('.');
                let /** @type {?} */ value = data;
                for(var /** @type {?} */ i = 0, /** @type {?} */ len = fields.length; i < len; ++i) {
                    if (value == null) {
                        return null;
                    }
                    value = value[fields[i]];
                }
                return value;
            }
        }
        else {
            return null;
        }
    }
/**
 * @param {?} value
 * @param {?} fields
 * @param {?} filterValue
 * @return {?}
 */
filter(value: any[], fields: any[], filterValue: string) {
        let /** @type {?} */ filteredItems: any[] = [];

        if(value) {
            for(let /** @type {?} */ item of value) {
                for(let /** @type {?} */ field of fields) {
                    if(String(this.resolveFieldData(item, field)).toLowerCase().indexOf(filterValue.toLowerCase()) > -1) {
                        filteredItems.push(item);
                        break;
                    }
                }
            }
        }

        return filteredItems;
    }
/**
 * @param {?} value
 * @param {?} from
 * @param {?} to
 * @return {?}
 */
reorderArray(value: any[], from: number, to: number) {
        let /** @type {?} */ target: number;
        if(value && (from !== to)) {
            if(to >= value.length) {
                target = to - value.length;
                while((target--) + 1) {
                    value.push(undefined);
                }
            }
            value.splice(to, 0, value.splice(from, 1)[0]);
        }
    }
/**
 * @param {?} val
 * @param {?} field
 * @return {?}
 */
generateSelectItems(val: any[], field: string): SelectItem[] {
        let /** @type {?} */ selectItems: SelectItem[];
        if(val && val.length) {
            selectItems = [];
            for(let /** @type {?} */ item of val) {
                selectItems.push({label: this.resolveFieldData(item, field), value: item});
            }
        }

        return selectItems;
    }
/**
 * @param {?} item
 * @param {?} index
 * @param {?} arr
 * @param {?} sourceArr
 * @return {?}
 */
insertIntoOrderedArray(item: any, index: number, arr: any[], sourceArr: any[]): void {
        if(arr.length > 0) {
            let /** @type {?} */ injected = false;
            for(let /** @type {?} */ i = 0; i < arr.length; i++) {
                let /** @type {?} */ currentItemIndex = this.findIndexInList(arr[i], sourceArr);
                if(currentItemIndex > index) {
                    arr.splice(i, 0, item);
                    injected = true;
                    break;
                }
            }

            if(!injected) {
                arr.push(item);
            }
        }
        else {
            arr.push(item);
        }
    }
/**
 * @param {?} item
 * @param {?} list
 * @return {?}
 */
findIndexInList(item: any, list: any): number {
        let /** @type {?} */ index: number = -1;

        if(list) {
            for(let /** @type {?} */ i = 0; i < list.length; i++) {
                if(list[i] == item) {
                    index = i;
                    break;
                }
            }
        }

        return index;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ObjectUtils_tsickle_Closure_declarations() {
/** @type {?} */
ObjectUtils.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ObjectUtils.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
